import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPages } from './pdfToImageActions';
import './PDFToImage.scss';

export default class PDFToImage extends Component {
    static propTypes = {
        onConversionComplete: PropTypes.func.isRequired,
        pdf: PropTypes.any.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            numberOfPages: 0
        };

        this.renderPages = this.renderPages.bind(this);
        this.renderCanvases = this.renderCanvases.bind(this);
    }

    componentDidMount() {
        getPages(this.props.pdf).then((pages) => {
            if (pages.length > 15) {
                this.props.onConversionComplete([], this.props.pdf.name, true);
            } else {
                this.setState({ numberOfPages: pages.length }, () => {
                    this.renderPages(pages); // pages now = array of base64 strings
                });
            }
        });
    }

    renderPages(pages) {
        // pages: array of base64 strings
        const images = pages.map((base64, index) => {
            const ref = this[`canvas${index}Ref`].current;
            const ctx = ref.getContext('2d');
            const img = new Image();

            return new Promise((resolve) => {
                img.onload = () => {
                    ref.width = img.width;
                    ref.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    resolve();
                };
                img.src = `data:image/png;base64,${base64}`;
            });
        });

        Promise.all(images).then(() => {
            this.props.onConversionComplete(
                pages.map((base64, index) => {
                    const data = this[`canvas${index}Ref`].current.toDataURL('image/png');

                    return {
                        data,
                        name: `${this.props.pdf.name}/page${index + 1}`,
                        size: Math.round((data.length - 'data:image/png;base64,'.length) * 3 / 4)
                    };
                }),
                this.props.pdf.name
            );
        });
    }

    renderCanvases() {
        const canvases = [];

        for (let i = 0; i < this.state.numberOfPages; i++) {
            this[`canvas${i}Ref`] = React.createRef();

            canvases.push(<canvas ref={this[`canvas${i}Ref`]} width={595} key={i}/>);
        }

        return (canvases);
    }

    render() {
        return (<div className="emvio-pdf-to-image">
            {this.renderCanvases()}
        </div>);
    }
}
